export default Object.freeze({
  NoBilling: 0,
  ProviderAutomatic: 1,
  DistributorCredit: 2,
  ManualInvoice: 3,
});
